// extracted by mini-css-extract-plugin
export default {"modal":"ActivateModal_modal__TE8jm","active":"ActivateModal_active__eEAXB","inactive":"ActivateModal_inactive__VMXo6"};